export default __webpack_public_path__ + "locales/si/EmbeddingPanel.json?hash=951b0b69a13bd4f458b4d692ef58bb73";